import Modal from "../../lib/ModalWindow/Modal";
import React from "react";
import {useTranslation} from "react-i18next";
import styles from "./AddedToWishlistModal.module.scss";
import {Button, ButtonType} from "../../lib/form/Button/Button";
import Image from "../../ProductSeries/Image";
import {useWishlistSelector} from "../../../store";

interface IAddedToWishlistProps {
  continueFunction: () => void;
  closeFunction: () => void;
}

const AddedToWishlistModal: React.FC<IAddedToWishlistProps> = ({closeFunction, continueFunction}) => {
  const {wishlist, itemIdToShowOnPopup} = useWishlistSelector();
  const {t} = useTranslation();

  if (!itemIdToShowOnPopup) {
    return null;
  }

  const addedItem = wishlist?.items.find((item) => item.item.itemId === itemIdToShowOnPopup)?.item;

  if (!addedItem) {
    return null;
  }

  const {title} = addedItem;

  return (
    <Modal isVisible={true} closeFunction={closeFunction}>
      <div>
        <table className={styles.contentTable}>
          <tbody>
            <tr>
              <td className={styles.imagePart}>
                <Image item={addedItem} />
              </td>
              <td>{t("wishlist.addedToWishlist--title", {title})}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <Button action={continueFunction} type={ButtonType.default}>
        {t("wishlist.gotToWishlist")}
      </Button>
    </Modal>
  );
};

export default AddedToWishlistModal;
